import { useRouter } from 'next/router'

export const useIsOnboarding = () => {
	const router = useRouter()
	return router.route.startsWith('/onboarding/')
}
